import { html } from 'lit';
import { Shield } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-shield')
export class PdsIconShield extends PdsIcon {
  @state()
  icon = Shield;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
